import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import ScenarioCompare from "@/pages/home/components/ScenarioCompare";
import RoleArchetypes from "@/pages/home/components/RoleArchetypes";
import ScenarioFilter from "@/pages/home/components/ScenarioFilter";
import InteractionDetails from "@/pages/home/components/InteractionDetails";
import ChapterGuide from "@/pages/home/components/ChapterGuide";
import ViewingPath from "@/pages/home/components/ViewingPath";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <ScenarioCompare />
        <RoleArchetypes />
        <ScenarioFilter />
        <InteractionDetails />
        <ChapterGuide />
        <ViewingPath />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}